import { useEffect, useState } from 'react';
import { supabaseClient } from '../../utils/supabase';
import { normalizeEmail } from './RecipientEditor';

/**
 * The addresses a dashboard Send dialog may deliver to: the merchant's
 * `email` and `alternative_email` on file (REG-675). The row usually carries
 * only `email`, so the record is read once per open; RLS scopes it to
 * merchants the rep can already see. Falls back to the row's email when the
 * lookup fails so the dialog never loses its default.
 */
export function useMerchantEmails(merchantId: number | null, rowEmail: string): string[] {
  const [emails, setEmails] = useState<string[]>([]);

  useEffect(() => {
    if (merchantId == null) {
      setEmails([]);
      return;
    }
    let cancelled = false;
    supabaseClient
      .from('merchant')
      .select('email, alternative_email')
      .eq('id', merchantId)
      .maybeSingle()
      .then(({ data }) => {
        if (cancelled) return;
        const found = [data?.email, data?.alternative_email]
          .map((value) => normalizeEmail(String(value ?? '')))
          .filter(Boolean);
        setEmails([...new Set([...found, ...(rowEmail ? [normalizeEmail(rowEmail)] : [])])]);
      });
    return () => {
      cancelled = true;
    };
  }, [merchantId, rowEmail]);

  return emails.length ? emails : (rowEmail ? [normalizeEmail(rowEmail)] : []);
}
